var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"kt_scrolltop",staticClass:"scrolltop iq-scroller",attrs:{"id":"kt_scrolltop"}},[_c('span',{staticClass:"text-white"},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("mdi-chevron-up")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }